import CryptoJS from 'crypto-js';
import { createTransform } from 'redux-persist';
import { EncKeys } from './config';

const encryptionTransform = createTransform(
  // Encrypt (inbound - when saving to localStorage)
  (inboundState, key) => {
    if (!inboundState) return inboundState;
    
    try {
      // Parse your encryption key and IV
      const encKey = CryptoJS.enc.Utf8.parse(EncKeys.VayanaEncKey);
      const iv = CryptoJS.enc.Utf8.parse(EncKeys.IV);
      
      // Convert state to JSON string
      const jsonString = JSON.stringify(inboundState);
      
      // Encrypt using your AES configuration
      const encrypted = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(jsonString),
        encKey,
        {
          keySize: 128 / 8,
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      );
      
      // Return encrypted string
      return encrypted.toString();
    } catch (error) {
      console.error('Redux encryption error:', error);
      return inboundState;
    }
  },
  
  // Decrypt (outbound - when loading from localStorage)
  (outboundState, key) => {
    if (!outboundState) return outboundState;
    
    try {
      // Parse your encryption key and IV
      const encKey = CryptoJS.enc.Utf8.parse(EncKeys.VayanaEncKey);
      const iv = CryptoJS.enc.Utf8.parse(EncKeys.IV);
      
      // Decrypt the encrypted string
      const decrypted = CryptoJS.AES.decrypt(
        outboundState,
        encKey,
        {
          keySize: 128 / 8,
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      );
      
      // Convert decrypted bytes to UTF8 string
      const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);
      
      // Parse JSON back to object
      return JSON.parse(decryptedString);
    } catch (error) {
      console.error('Redux decryption error:', error);
      return outboundState;
    }
  }
);

export default encryptionTransform;
